
export default {
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Goa, Goa Tourism, Travel Guide, Watersports, Goa Beaches, Romantic Places, Waterfalls, Hidden Places, Must Visit places in Goa, Dudhsagar Waterfalls, Calangute Beach, Palolem Beach, Grand Island Goa, Old Goa Church, Bom Jesus Church, Visit goa, Things to do in Goa, Travel Agency",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title + " | Goa App",
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title + " | Goa App",
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      ],
    };
  },
  data() {
    return {
      title: 'Add Place',
      description: 'Promote your event on Goa App for free!!',
      categoriesData: null,
      typeList: [],
      categoriesList: null,
      form: {
        eventName: null,
        location: null,
        shortDesc: null,
        longDesc: null,
        guidelines: null,
        coverImage: [],
        hostName: null,
        email: null,
        phone: null,
        stateId: null,
        areaId: null,
        cityId: null,
        typeId: null,
        location: {
          address: null,
          latitude: null,
          longitude: null,
        },
        tags: {
          addTag: null,
          tagsList: []
        },
      },
      states: null,
      cities: [],
      areas: [],
      filteredAreas: [],
      filteredCities: [],
      //Form error variables
      errors: {
        formError: null,
        errorMsg: "<strong>Opps! Something went wrong,</strong> please try again."
      },
      // Form submit variables
      submit: {
        loading: false,
        success: false,
        errored: false
      },
    }
  },
  mounted() {
    this.getStates();
    this.getData();

  },
  methods: {
    async getData() {
      this.categoriesData = await fetch(this.$config.fetchUrl + '/api/activityTypes/app/getTypeDetails/events/').then(res => res
        .text());
      this.categoriesData = this.getCryptKey(this.categoriesData);
    },

    async getStates() {
      this.typeList = await fetch(
        this.$config.fetchUrl + '/api/activityTypes/getTypesWithCategories/'
      ).then(res => res.text())
      this.typeList = this.getCryptKey(this.typeList);
      this.filterTypeList();
      this.states = await fetch(
        this.$config.fetchUrl + '/api/states/'
      ).then(res => res.text())
      this.states = this.getCryptKey(this.states);
      this.areas = await fetch(
        this.$config.fetchUrl + '/api/areas/'
      ).then(res => res.text())
      this.areas = this.getCryptKey(this.areas);
      // Get list of cities
      this.cities = await fetch(
        this.$config.fetchUrl + '/api/cities/'
      ).then(res => res.text())
      this.cities = this.getCryptKey(this.cities);

    },

    filterTypeList() {
      let slug_filter = ['places', 'blogs', 'restaurants']
      if (this.typeList && this.typeList.length > 0) {
        this.typeList = this.typeList.filter(type => slug_filter.includes(type.slug))
      }
    },

    // To get category list based on the activity type selected
    getCategoriesList(postTypeId) {
      this.form.categoriesList = [];
      // array function to find the id with matches the one selected from activity type dropdown
      let filterActivityType = this.typeList.find(x => x._id === postTypeId);
      this.categoriesList = filterActivityType.categories;
    },

    getAreasList(event) {
      this.form.areaId = null;
      this.form.cityId = null;
      this.filteredAreas = [];
      this.filteredCities = [];
      // array function to find the id with matches the one selected from activity type dropdown
      let filteredAreas = this.areas.filter(x => x.state === event.target.value);
      this.filteredAreas = filteredAreas;
    },

    getCitiesList(event) {
      this.form.cityId = null;
      this.filteredCities = [];
      // array function to find the id with matches the one selected from activity type dropdown
      let filteredCities = this.cities.filter(x => x.area === event.target.value && x.state === this.form.stateId);
      this.filteredCities = filteredCities;
    },

    getPostType(typeId) {
      let typeSlugList = this.typeList.filter(x => x._id === typeId);
      if (typeSlugList && typeSlugList.length > 0) {
        let typeSlug = typeSlugList[0].slug
        switch (typeSlug) {
          case 'place':
          case 'places':
            return 'place';
          case 'restaurant':
          case 'restaurants':
            return 'restaurant';
          case 'blog':
          case 'blogs':
            return 'blog';
          default:
            return 'place'
        }
      }
      else {
        return 'place'
      }
    },

    // To add tag to the tags list
    addTag(tagToAdd) {
      let tagItem = tagToAdd.toLowerCase();
      var tag = tagItem.split(',');
      const found = this.form.tags.tagsList.some(r => tag.includes(r))
      if (!found) {
        this.form.tags.tagsList.push(...tag);
      }
      else {
        this.$refs.eventForm.setErrors({
          validateTag: ['Tag already exists']
        });
        return;
      }
      this.form.tags.addTag = null;
    },

    // Remove a tag from the tag list
    removeTag(id) {
      this.form.tags.tagsList.splice(id, 1);
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload(e) {
      let uploadedFiles = this.$refs.files.files;
      /*
        Adds the uploaded file to the files array
      */
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.form.coverImage.push(uploadedFiles[i]);
      }
      if (this.form.coverImage.length < 1) {
        this.$refs.coverImage.validate(e);
      }
      else {
        this.$refs.eventForm.setErrors({
          coverImage: []
        });
      }
      this.$refs.files.value = null;
    },
    //To remove an uploaded file on click of button, and trigger the errors
    removeFiles(key) {
      this.form.coverImage.splice(key, 1);
      if (this.form.coverImage.length < 1) {
        this.$refs.eventForm.setErrors({
          coverImage: ['Cover image required']
        });
      }
      else {
        this.$refs.eventForm.setErrors({
          coverImage: []
        });
      }
    },
    getFilePreview(imageFile) {
      return URL.createObjectURL(imageFile);
    },

    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      return str;
    },

    // To clear the submit error message
    clearFormErrMsg() {
      this.errors.formError = null;
      this.submit.success = false;
      this.submit.errored = false;
    },

    // To reset the form after successful submit
    resetForm() {
      var self = this; //you need this because *this* will refer to Object.keys below`
      //Iterate through each object field, key is name of the object field`
      Object.keys(this.form).forEach(function (key, index) {
        if (typeof self.form[key] != ("object" || "array")) {
          self.form[key] = null;
        }
      });
      Object.keys(this.form.location).forEach(function (key, index) {
        if (typeof self.form.location[key] != ("object" || "array")) {
          self.form.location[key] = null;
        }
      });
      this.form.coverImage = [];
      this.form.tags.tagsList = [];
      this.$refs.eventForm.reset();
    },

    // Validate and Submit form data to a add event
    sendMessage() {
      // Clear all submit errors before API call
      this.errors.formError = null;
      this.submit.success = false;
      this.submit.errored = false;
      // Validate all fields for making the API call, throw error and not call API if validation errors are present
      this.$refs.eventForm.validate().then((success) => {
        if (!success || (this.form.tags.tagsList.length < 1 && this.form.tags.addTag != (null || ''))) {
          // run your error code here
          if (this.form.tags.tagsList.length < 1 && this.form.tags.addTag != (null || '')) {
            this.$refs.eventForm.setErrors({
              validateTag: ['Click ADD button to add the tags']
            });
          }
          this.errors.formError = "One or more incorrect fields present, please fix.";
        }
        else {
          // If Valid form
          // Create formData instance to pass the data to the API
          var formData = new FormData();
          if (this.form.coverImage && this.form.coverImage.length > 0) {
            this.form.coverImage.forEach(coverImage => {
              formData.append('gallery', coverImage);
            })
          }
          this.form.tags.tagsList.forEach(tag => {
            formData.append('tags', tag);
          })
          this.form.categoriesList.forEach(category => {
            formData.append('categories', category._id);
          })
          formData.append("state", this.form.stateId);
          formData.append("area", this.form.areaId);
          formData.append("city", this.form.cityId);
          formData.append("typeId", this.form.typeId);
          if (this.form.typeId)
            formData.append("postType", this.getPostType(this.form.typeId));
          formData.append("name", this.form.eventName.trim());
          formData.append("slug", this.string_to_slug(this.form.eventName.trim().toLowerCase()));
          formData.append("shortDescription", this.form.shortDesc.trim());
          if (this.form.longDesc) {
            formData.append("text", this.form.longDesc.trim());
          }
          if (this.form.guidelines)
            formData.append("guidelines", this.form.guidelines.trim());
          formData.append("location[address]", this.form.location.address.trim());
          formData.append("location[latitude]", this.form.location.latitude.trim());
          formData.append("location[longitude]", this.form.location.longitude.trim());

          // Add header for the API
          const headers = {
            'Content-Type': 'multipart/form-data',
          }
          this.submit.loading = true;
          // AXIOS api call to add categories api
          this.$axios
            .post("/api/posts/", formData, { headers: headers })
            .then(response => {
              this.submit.success = true;
              this.submit.errored = false;
              this.$bvModal.show('create-event');
              this.resetForm();
            })
            .catch(error => {
              if (error.response.data) {
                if (error.response.data.toLowerCase().includes("duplicate key error")) {
                  if (error.response.data.toLowerCase().includes("name")) {
                    this.errors.errorMsg = "<strong>Event name exists,</strong> please use another name."
                  }
                }
              }
              this.submit.success = false;
              this.submit.errored = true;
            })
            .finally(() => {
              this.submit.loading = false;
            });
        }
      });
    }

  }
}
